import React from 'react';
import {
  PEDIATRIC_CENTRE_ROLES,
  ROLE_PEDIATRIC_CENTRE_HEREDITARY_METABOLIC_DISEASES,
} from '../../constants/roles';
import RouteDefinition from '../../helpers/Route/RouteDefinition';

// eslint-disable-next-line import/prefer-default-export
export const pediatricCentreRoutes = {
  dashboard: new RouteDefinition({
    path: '/pediatric-centre/dashboard',
    component: React.lazy(() => import('./Dashboard')),
    roles: PEDIATRIC_CENTRE_ROLES,
  }),
  samplesList: new RouteDefinition({
    path: '/newborn/:newbornId/samples-list',
    component: React.lazy(() => import('./Sample/List')),
    roles: PEDIATRIC_CENTRE_ROLES,
    register: false,
  }),
  recallsList: new RouteDefinition({
    path: '/pediatric-centre/recalls/list',
    component: React.lazy(() => import('./Recalls')),
    roles: ROLE_PEDIATRIC_CENTRE_HEREDITARY_METABOLIC_DISEASES,
  }),
  reportList: new RouteDefinition({
    path: '/pediatric-centre/reports/',
    component: React.lazy(() => import('./Report')),
    roles: ROLE_PEDIATRIC_CENTRE_HEREDITARY_METABOLIC_DISEASES,
    exact: false,
  }),
  reportArchive: new RouteDefinition({
    path: '/pediatric-centre/reports/archive',
    component: React.lazy(() => import('./Report/Archive')),
    roles: ROLE_PEDIATRIC_CENTRE_HEREDITARY_METABOLIC_DISEASES,
    register: false,
  }),
  pendingReport: new RouteDefinition({
    path: '/pediatric-centre/reports/pending',
    component: React.lazy(() => import('./Report/Pending')),
    roles: ROLE_PEDIATRIC_CENTRE_HEREDITARY_METABOLIC_DISEASES,
    register: false,
  }),
  serumSampleArchive: new RouteDefinition({
    path: '/pediatric-centre/reports/serum',
    component: React.lazy(() => import('./Report/SerumSampleArchive')),
    roles: ROLE_PEDIATRIC_CENTRE_HEREDITARY_METABOLIC_DISEASES,
    register: false,
  }),
};
